const txteng10b = [
  ["я купил машину на прошлой неделе.", "I bought a car last week."],
  ["Он встретил меня там в среду.", "He met me there on Wednesday."],
  ["Они получили документы в пятницу.", "They got the documents on Friday."],
  ["Ты хотел придти позавчера", "You wanted to come the before yesterday."],
  [
    "Когда это случилось, они были на работе.",
    "When it happened they were at work",
  ],
  [
    "Мне понравилось все, что я видел во вторник",
    "I liked everything I saw on Tuesday.",
  ],
  ["Я думал об этом на прошлых выходных", "I thought about it last weekend."],
  ["Она узнала меня, когда я пришел.", "She recognized me when I came."],
  [
    "В четверг я был дома, а они были на работе.",
    "I was at home and they were at work on Thursday",
  ],
  ["У меня был плохой день в понедельник.", "I had a bad day on Monday."],
  [
    "Она продала дом в декабре и поехала в Бостон",
    "She sold the house in December and went to Boston.",
  ],
  ["Она думала, что у меня были деньги.", "She thought I had money."],
  ["Когда вы приехали, он был дома.", "When you came he was at home."],
  [
    "Я выбрал все, что мне было нужно и купил это.",
    "I chose everything I needed and bought it.",
  ],
  [
    "Мы сделали это, когда она продала все.",
    "We did it when she sold everything.",
  ],
  [
    "Она сделала это 5 минут назад и мы пошли домой.",
    "She did it five minutes ago and we went home.",
  ],
  [
    "У них был дом, когда они жили там.",
    "They had a house when they lived there.",
  ],
  ["Она получала деньги каждый месяц.", "She got money every month."],
  [
    "Когда мы приехали сюда, она купила машину.",
    "When we came here she bought a car.",
  ],
  ["Это случалось каждую неделю.", "It happened every week."],
  ["Мы сделали все, что она хотела.", "We did everything she wanted."],
  [
    "Я хотел быть там и мы поехали туда в мае.",
    "I wanted to be there and we went there in May.",
  ],
  [
    "Когда мы были маленькими, у меня была собака, а у нее был кот.",
    "When we were little, I had a dog and she had a cat.",
  ],
  ["Я подождал и пошел домой.", "I waited for a while and went home."],
  [
    "Он купил дом в октябре и продал его в июне.",
    "He bought the house in October and sold it in June.",
  ],
];

export default txteng10b;
